const a = { boolean: (e) => typeof e == "string" ? e === "true" : !!e, isTabbable: (e) => {
  const t = e.tagName.toLowerCase();
  return e.getAttribute("tabindex") !== "-1" && !e.hasAttribute("disabled") && (!e.hasAttribute("aria-disabled") || e.getAttribute("aria-disabled") === "false") && e.offsetParent !== null && window.getComputedStyle(e).visibility !== "hidden" && (!(t !== "audio" && t !== "video" || !e.hasAttribute("controls")) || !!e.hasAttribute("tabindex") || !(!e.hasAttribute("contenteditable") || e.getAttribute("contenteditable") === "false") || ["button", "input", "select", "textarea", "a", "audio", "video", "summary"].includes(t));
} };
export {
  a as p
};
